import React from 'react';
import { BENEFITS } from '../data/content';
import { Reveal } from './Reveal';
export function Benefits() {
  return <section id="ventajas" className="bg-canvas py-20 sm:py-24" data-id="element-16" data-mp="9c792mowepjy">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8" data-id="element-17" data-mp="4k5zx9n11ey5">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-18" data-mp="4il5rl4mjy0t">
          <p className="text-[11px] font-semibold uppercase tracking-overline text-brand-600" data-id="element-19" data-mp="3vridleopba9b">
            Ventajas
          </p>
          <h2 className="mt-4 text-[2rem] font-semibold leading-[1.1] tracking-[-0.02em] text-ink-900 sm:text-[2.6rem]" data-id="element-20" data-mp="3qt73d2uhuxqk">
            Diseñado para tu forma de operar
          </h2>
        </Reveal>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-21" data-mp="3hrhd40ccm4ud">
          {BENEFITS.map((benefit, i) => <Reveal key={benefit.number} delay={i % 3 * 0.05} className="h-full" data-id="element-22" data-mp="3ctz6whppu3q2" data-mpi={i}>
              <li className="flex h-full flex-col rounded-2xl border border-line bg-white p-7 shadow-card transition-[transform,box-shadow] duration-200 ease-expo hover:-translate-y-1 hover:shadow-lift" data-id="element-23" data-mp="1fyt8pnnyxbd0">
                <span className="text-[13px] font-semibold tracking-[0.08em] text-brand-400" data-id="element-24" data-mp="2pwmk14781q9">
                  {benefit.number}
                </span>
                <h3 className="mt-4 text-[17px] font-semibold tracking-[-0.01em] text-ink-900" data-id="element-25" data-mp="3oz7jhrvx69t4">
                  {benefit.title.charAt(0) + benefit.title.slice(1).toLowerCase()}
                </h3>
                <p className="mt-3 text-[14.5px] leading-relaxed text-ink-500" data-id="element-26" data-mp="lhfkhtjd8plf">
                  {benefit.description}
                </p>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}